module.exports = __webpack_public_path__ + "static/media/20_WAX.fbddefd5.webp";